import { AddBusinessAdmin, BusinessAdmin, PermissionList } from '../../pages';
import { EmployeeController, UserController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import { userStore } from '../../stores';
import React, { useState } from 'react';
import { toJS } from 'mobx';

const PermissionListContainer = ({ closeModal }) => {
	const [permissions, setPermissions] = useState('');
	const [savePermissions, setSavePermissions] = useState(false);
	const [loading, setLoading] = useState(false);

	const showPermissions = i => {
		if (permissions === i) {
			return setPermissions(' ');
		} else {
			setPermissions(i);
		}
	};

	const showSavedPermissions = () => {
		setSavePermissions(true);
	};

	const onSubmit = async values => {
		const payload = values.ids.map(x => x._id);
		if (payload.length === 0) {
			return MimaToastUtil.error({
				message: 'Select Permissions to proceed',
			});
		}

		setLoading(true);
		const { status, errorMessage } = await UserController.setAdminPermissions(
			{ permission: payload },
			userStore.selectedAdmin.user._id
		);
		
		if (status === constant.Success) {
			setLoading(false);
			userStore.setSelectedAdmin({});
			MimaToastUtil.success({
				message: constant.Success,
			});
			
			return closeModal();		
		}
		setLoading(false);
		MimaToastUtil.error({
			message: errorMessage,
		});
		return closeModal();
	};

	return (
		<PermissionList
			permissions={permissions}
			admin={userStore.selectedAdmin}
			availablePermissions={toJS(userStore.permissions)}
			showPermissions={showPermissions}
			savePermissions={savePermissions}
			showSavedPermissions={showSavedPermissions}
			closeModal={closeModal}
			onSubmit={onSubmit}
			loading={loading}
		/>
	);
};

export default PermissionListContainer;
